import React from 'react'
import { defineMessage } from 'react-intl'

import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

import { CoverageNotice } from '../atoms/coverageNotice/CoverageNotice'

export const akamai: GetCustomerCopyFunc = ({ numberOfSessions }) => {
  return {
    servicesNotCovered:
      'Services that are not covered include: inpatient or residential treatment, hospitalization (including partial), intensive outpatient treatment, emergent care, long-term care or counseling, autism spectrum disorder treatment, services for remedial education, executive coaching, and non-evidence-based behavioral health care. Please check with your medical plan or benefits portal for coverage of these excluded services.',
    legalNotice: (
      <CoverageNotice
        sessionLimit={numberOfSessions}
        excludedServices={defineMessage({
          defaultMessage:
            'Lyra does not cover inpatient or residential treatment, hospitalization (including partial), intensive outpatient treatment, emergent care, long-term care or counseling, autism spectrum disorder treatment, services for remedial education, executive coaching, and non-evidence-based behavioral health care.',
          description:
            'Text for describing the services that Lyra does not cover, displayed as part of the coverage notice',
        })}
      />
    ),
  }
}
